import {Component, OnInit} from '@angular/core';
import {Product} from "libs/shared-models/src/lib/product-type";
import {CurrentProductService} from "../../../../../../libs/shared-services/src/lib/current-product.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {Router} from "@angular/router";

@UntilDestroy()
@Component({
  selector: 'account-logo',
  templateUrl: './account-logo.component.html',
  styleUrls: ['./account-logo.component.scss'],
})
export class AccountLogoComponent implements OnInit {

    private product: Product = Product.UNDEFINED;

    constructor(
        private currentProductService: CurrentProductService,
        private router: Router
    ) {
    }

    public ngOnInit() {
        this.currentProductService.$getProduct().pipe(untilDestroyed(this)).subscribe((p) => this.product = p)
    }

    public getProductType(): Product {
        return this.product;
    }

    public pressed() {
        this.router.navigateByUrl("login");
    }
}
